<div class="app-page" fxFill>

  <div style="margin-left: 20px; margin-top: 20px;">
    @if (this.editUser) {
      <form [formGroup]="editUser">
        <input  type="hidden"  formControlName="Email">
        <input  type="hidden" placeholder="Username" formControlName="UserName">
        <label style="font-family: Roboto; font-size: small; color: rgba(255, 255, 255, 0.7)" >User name</label><br/>
        <label style="font-family: Roboto;" >{{this.user.UserName}}</label>
        <br/>
        <mat-form-field style="width: 350px;">
          <input matInput placeholder="First name" formControlName="FirstName" [disabled]="this.user.ConnectedPlayer">
        </mat-form-field>
        <br/>
        <mat-form-field style="width: 350px;">
          <input matInput placeholder="Last name" formControlName="LastName"  >
        </mat-form-field><br/>
        <mat-form-field>
          <mat-label>Color</mat-label>
          <mat-select formControlName="UserBgColor">
            <mat-option value="#FF6633">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #FF6633; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Orange
              </div>
            </mat-option>
            <mat-option value="#FFB399">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #FFB399; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light orange
              </div>
            </mat-option>
            <mat-option value="#FF33FF">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #FF33FF; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Magenta
              </div>
            </mat-option>
            <mat-option value="#00B3E6">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #00B3E6; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Cyan
              </div>
            </mat-option>
            <mat-option value="#E6B333">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #E6B333; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Gold
              </div>
            </mat-option>
            <mat-option value="#3366E6">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #3366E6; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Blue
              </div>
            </mat-option>
            <mat-option value="#999966">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #999966; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Olive
              </div>
            </mat-option>
            <mat-option value="#99FF99">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #99FF99; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light green
              </div>
            </mat-option>
            <mat-option value="#B34D4D">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #B34D4D; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Red
              </div>
            </mat-option>
            <mat-option value="#80B300">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #80B300; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Yellow green
              </div>
            </mat-option>
            <mat-option value="#809900">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #809900; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Yellow
              </div>
            </mat-option>
            <mat-option value="#E6B3B3">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #E6B3B3; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light red
              </div>
            </mat-option>
            <mat-option value="#6680B3">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #6680B3; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light blue
              </div>
            </mat-option>
            <mat-option value="#66991A">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #66991A; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Olive green
              </div>
            </mat-option>
            <mat-option value="#FF99E6">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #FF99E6; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light magenta
              </div>
            </mat-option>
            <mat-option value="#CCFF1A">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #CCFF1A; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light yellow
              </div>
            </mat-option>
            <mat-option value="#FF1A66">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #FF1A66; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light pink
              </div>
            </mat-option>
            <mat-option value="#E6331A">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #E6331A; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Dark red
              </div>
            </mat-option>
            <mat-option value="#33FFCC">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #33FFCC; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light teal
              </div>
            </mat-option>
            <mat-option value="#66994D">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #66994D; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Dark olive green
              </div>
            </mat-option>
            <mat-option value="#B366CC">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #B366CC; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light purple
              </div>
            </mat-option>
            <mat-option value="#4D8000">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #4D8000; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Dark green
              </div>
            </mat-option>
            <mat-option value="#B33300">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #B33300; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Dark orange
              </div>
            </mat-option>
            <mat-option value="#CC80CC">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #CC80CC; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light pink
              </div>
            </mat-option>
            <mat-option value="#66664D">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #66664D; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Dark gray
              </div>
            </mat-option>
            <mat-option value="#991AFF">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #991AFF; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Dark violet
              </div>
            </mat-option>
            <mat-option value="#E666FF">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #E666FF; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light violet
              </div>
            </mat-option>
            <mat-option value="#4DB3FF">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #4DB3FF; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light blue
              </div>
            </mat-option>
            <mat-option value="#1AB399">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #1AB399; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Dark cyan
              </div>
            </mat-option>
            <mat-option value="#E666B3">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #E666B3; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light magenta
              </div>
            </mat-option>
            <mat-option value="#33991A">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #33991A; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Dark green
              </div>
            </mat-option>
            <mat-option value="#CC9999">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #CC9999; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light gray
              </div>
            </mat-option>
            <mat-option value="#B3B31A">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #B3B31A; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Olive green
              </div>
            </mat-option>
            <mat-option value="#00E680">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #00E680; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Bright teal
              </div>
            </mat-option>
            <mat-option value="#4D8066">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #4D8066; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Dark teal
              </div>
            </mat-option>
            <mat-option value="#809980">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #809980; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Sage green
              </div>
            </mat-option>
            <mat-option value="#E6FF80">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #E6FF80; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light green
              </div>
            </mat-option>
            <mat-option value="#1AFF33">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #1AFF33; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Bright green
              </div>
            </mat-option>
            <mat-option value="#999933">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #999933; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Olive drab
              </div>
            </mat-option>
            <mat-option value="#FF3380">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #FF3380; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light coral
              </div>
            </mat-option>
            <mat-option value="#CCCC00">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #CCCC00; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Yellow
              </div>
            </mat-option>
            <mat-option value="#66E64D">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #66E64D; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light green
              </div>
            </mat-option>
            <mat-option value="#4D80CC">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #4D80CC; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Dark blue
              </div>
            </mat-option>
            <mat-option value="#9900B3">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #9900B3; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Dark magenta
              </div>
            </mat-option>
            <mat-option value="#E64D66">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #E64D66; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light red
              </div>
            </mat-option>
            <mat-option value="#4DB380">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #4DB380; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Medium teal
              </div>
            </mat-option>
            <mat-option value="#FF4D4D">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #FF4D4D; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light red
              </div>
            </mat-option>
            <mat-option value="#99E6E6">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #99E6E6; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light cyan
              </div>
            </mat-option>
            <mat-option value="#6666FF">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #6666FF; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Medium blue
              </div>
            </mat-option>
          </mat-select>
        </mat-form-field>
        <!--   <mat-checkbox formControlName="AllTeams">All teams</mat-checkbox>
        <br/>
        <mat-checkbox formControlName="AllSeasons">All seasons</mat-checkbox> -->
        <br>
          <mat-checkbox id="WebCalendarEnabled"
          formControlName="WebCalendarEnabled">Web calendar</mat-checkbox>
          @if (this.user.ConnectedPlayer) {
            <div>
              <h2 style="font-family: Roboto;">
                Connected player
              </h2>
              <div style="font-family: Roboto;">
                User is connected to this player in database
              </div>
              <div>
                <table>
                  <tr>
                    <td>
                    </td>
                    <td>
                      <a [routerLink]="['/player/details', this.user.ConnectedPlayer.PlayerId]" style="color: White; font-size: large;">
                        {{this.user.ConnectedPlayer.LastName}}, {{this.user.ConnectedPlayer.FirstName}}
                      </a>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          }
          @if (!this.user.ConnectedPlayer) {
            <div style="display: flex; flex-direction: row; flex-wrap: wrap; "      >
              <div style="max-width: 390px;" >
                <h2 style="font-family: Roboto;">
                  Scouting - Roles
                </h2>
                <div style="margin-left: 20px;">
                  <div style="font-family: Roboto;">
                    Changes in roles require the user to login again before they are active.
                  </div>
                  <br/>
                  <mat-checkbox id="RoleOrgadmin"
                  formControlName="RoleOrgadmin">Administrator</mat-checkbox>
                  <br/>
                  <br/>
                  <mat-checkbox id="RoleScout"
                  formControlName="RoleScout">Scout</mat-checkbox>
                  <br/>
                  <br/>
                  <mat-checkbox id="RoleAllReports"
                  formControlName="RoleAllReports">Reports and notes - ALL</mat-checkbox>
                  <br/>
                  <mat-checkbox id="RoleAllGameRatings"
                  formControlName="RoleAllGameRatings">Game grades - ALL</mat-checkbox>
                  <br/>
                  <mat-checkbox id="RoleAllCalendarEvents"
                  formControlName="RoleAllCalendarEvents">Calendar - ALL</mat-checkbox>
                  <br/>
                  <mat-checkbox id="RoleAllPlayerTags"
                  formControlName="RoleAllPlayerTags">Player tags - ALL</mat-checkbox>
                  <br/>
                  <mat-checkbox id="RoleStatisticsViewer"
                  formControlName="RoleStatisticsViewer">Statistics - ALL</mat-checkbox>
                  <br/>
                  <mat-checkbox id="RoleStatisticsEditor"
                  formControlName="RoleStatisticsEditor">Statistics Editor</mat-checkbox>
                  <br/>
                  <mat-checkbox id="RoleOrgPlayeradmin"
                  formControlName="RoleOrgPlayeradmin">Add player to roster</mat-checkbox>
                  <br/>
                </div>
              </div>
              @if (false) {
                <div style="max-width: 390px;">
                  <h2 style="font-family: Roboto;">
                    Scouting - scout access rights
                  </h2>
                  <div style="font-family: Roboto;">
                  </div>
                  <div formArrayName="UserSecurity">
                    <div  STYLE="display: flex; flex-direction: row;">
                      <div style="width: 200px; font-family: Roboto;" >
                        Scout
                      </div>
                      <div style="width: 120px; font-family: Roboto;" >
                        Reports
                      </div>
                      <div  style="width: 120px;font-family: Roboto;">
                        Notes
                      </div>
                      <div style="width: 120px;font-family: Roboto;">
                        Grades
                      </div>
                      <div style="width: 120px;font-family: Roboto;">
                        Statistics
                      </div>
                    </div>
                    @for (access of UserSecurity.controls; track access; let i = $index) {
                      <div >
                        <div [formGroupName]="i" STYLE="display: flex; flex-direction: row; border-bottom: gray solid 1px;">
                          <div style="width: 200px; font-family: Roboto;" >
                            {{this.editUser.controls['UserSecurity'].controls[i].controls.Value.value}}<br/>
                          </div>
                          <div  style="width: 120px;">
                            <mat-checkbox formControlName="ReportAccessIschecked"
                            ></mat-checkbox>
                          </div>
                          <div style="width: 120px;">
                            <mat-checkbox formControlName="NoteAccessIschecked"
                            ></mat-checkbox>
                          </div>
                          <div style="width: 120px;">
                            <mat-checkbox formControlName="GameRatingAccessIschecked"
                            ></mat-checkbox>
                          </div>
                          <div style="width: 120px;">
                            <mat-checkbox formControlName="StatisticsAccessIschecked"
                            ></mat-checkbox>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
              <div style="max-width: 390px;">
                <h2 style="font-family: Roboto;">
                  Roles
                </h2>
                <div style="margin-left: 20px;">
                  <label class="roledescription">A role gives the user rights to perform actions on specific data object.</label>
                  <div  class="roledescription">
                    Changes in roles require the user to login again before they are active.
                  </div>
                  <br/>
                  <mat-checkbox id="Role_TeamManager"
                  formControlName="Role_TeamManager">Team manager - required for Testcenter use</mat-checkbox>
                  <br/>
                  <br/>
                  <mat-checkbox id="Role_ScoutingAdmin"
                  formControlName="Role_ScoutingAdmin">Scouting administrator</mat-checkbox>
                  <br/>
                  <mat-checkbox id="Role_ScoutingScout"
                  formControlName="Role_ScoutingScout">Scout</mat-checkbox>
                  <br/>
                  <br/>
                  <mat-checkbox id="Role_MedicalAdmin"
                  formControlName="Role_MedicalAdmin">Medical administrator</mat-checkbox>
                  <br/>
                  <mat-checkbox id="Role_MedicalViewer"
                  formControlName="Role_MedicalViewer">Medical viewer</mat-checkbox>
                  <br/>
                  <div  class="roledescription">
                    Allow user to access injury information
                  </div>
                  <br/>
                  <mat-checkbox id="Role_TestAdmin"
                  formControlName="Role_TestAdmin">Test administrator</mat-checkbox>
                  <br/>
                  <mat-checkbox id="Role_TestPerformer"
                  formControlName="Role_TestPerformer">Test performer</mat-checkbox>
                  <br/>
                  <mat-checkbox id="Role_TestViewer"
                  formControlName="Role_TestViewer">Test viewer</mat-checkbox>
                  <br/>
                  <br/>
                  <mat-checkbox id="Role_StatisticsAdmin"
                  formControlName="Role_StatisticsAdmin">Statistics administrator</mat-checkbox>
                  <br/>
                  <mat-checkbox id="Role_StatisticsEditor"
                  formControlName="Role_StatisticsEditor">Statistics editor</mat-checkbox>
                  <br/>
                  <mat-checkbox id="Role_StatisticsViewer"
                  formControlName="Role_StatisticsViewer">Statistics viewer</mat-checkbox>
                  <br/>
                  <br/>
                  <mat-checkbox id="Role_PerformanceViewer"
                  formControlName="Role_PerformanceViewer">Performance viewer</mat-checkbox>
                  <br/>
                  <div  class="roledescription">
                    Allow user to view player grades
                  </div>
                  <!-- <br/>
                  <mat-checkbox id="Role_Load_All"
                  formControlName="Role_Load_All">Player load, physical status, assessments - ALL</mat-checkbox> -->
                  <br/>
                  <mat-checkbox id="Role_Load_AllPhysicalStatus"
                  formControlName="Role_Load_AllPhysicalStatus">Physical status viewer</mat-checkbox>
                  <br/>
                  <div  class="roledescription">
                    Allow user to view player status and load
                  </div>
                  <br/>
                  <mat-checkbox id="Role_ObjectiveEditor"
                  formControlName="Role_ObjectiveEditor">Objective Editor</mat-checkbox>
                  <br/>
                  <br/>
                  <mat-checkbox id="Role_ContactsEditor"
                  formControlName="Role_ContactsEditor">Player contacts editor</mat-checkbox>
                  <br/>
                  <mat-checkbox id="Role_ContactsViewer"
                  formControlName="Role_ContactsViewer">Player contacts viewer</mat-checkbox>
                  <br/>
                  <div  class="roledescription">
                    Allow user to view or edit player contact information
                  </div>
                  <br/>
                  <mat-checkbox id="Role_TrainingMgr"
                  formControlName="Role_TrainingMgr">Training Manager</mat-checkbox>
                  <br/>
                  <label class="roledescription">Enables user to create training programs, workouts, exercises</label>
                  <br/>
                  <mat-checkbox id="Role_FormsAdmin"
                  formControlName="Role_FormsAdmin">Forms Admin</mat-checkbox>
                  <br/>
                  <label class="roledescription">Enables user to create new forms and delete any submitted form</label>
                  <br/>
                  <mat-checkbox id="Role_FormsViewer"
                  formControlName="Role_FormsViewer">Forms Viewer</mat-checkbox>
                  <br/>
                  <label class="roledescription">Enables user to see submitted forms</label>
                  <br/>
                  <mat-checkbox id="Role_FormsSubmitter"
                  formControlName="Role_FormsSubmitter">Forms Submitter</mat-checkbox>
                  <br/>
                  <label class="roledescription">Enables user to submit forms</label>
                  <br/>
                  <br/>
                  <mat-checkbox id="Role_UserAdmin"
                  formControlName="Role_UserAdmin">User Admin</mat-checkbox>
                  <br/>
                  <label class="roledescription">Enables user to create edit user information</label>
                </div>
              </div>
              <div >
                <h2 style="font-family: Roboto;">
                  Team access
                </h2>
                <div  class="roledescription">
                  Assing what data the user can see in each team. <br/>
                </div>
                <div formArrayName="LoadAccessRights">
                  <div  STYLE="display: flex; flex-direction: row;">
                    <div style="width: 200px; font-family: Roboto;" >
                    </div>
                    <div  style="width: 100px;font-family: Roboto;">
                      Grades
                    </div>
                    <div style="width: 100px;font-family: Roboto;">
                      Status
                    </div>
                    <div style="width: 100px;font-family: Roboto;">
                      Load
                    </div>
                    <div style="width: 100px;font-family: Roboto;">
                      Test
                    </div>
                    <div style="width: 100px;font-family: Roboto;">
                      Injury
                    </div>
                    <div style="width: 100px;font-family: Roboto;">
                      Objective
                    </div>
                    <div style="width: 100px;font-family: Roboto;">
                      Contacts
                    </div>
                    <!--     <div style="width: 100px;font-family: Roboto;">
                    Training
                  </div> -->
                  <div style="width: 100px;font-family: Roboto;">
                    Forms
                  </div>
                </div>
                @for (team of LoadAccessRights.controls; track team; let i = $index) {
                  <div >
                    <div [formGroupName]="i" STYLE="display: flex; flex-direction: row; border-bottom: gray solid 1px;">
                      <div style="width: 200px; font-family: Roboto; font-weight: bold;" >
                        {{this.editUser.controls['LoadAccessRights'].controls[i].controls.Value.value}}<br/>
                      </div>
                      <div  style="width: 100px;">
                        <mat-checkbox formControlName="Access_PlayerGameRankings"
                        ></mat-checkbox>
                      </div>
                      <div style="width: 100px;">
                        <mat-checkbox formControlName="Access_PhysicalStatus"
                        ></mat-checkbox>
                      </div>
                      <div style="width: 100px;">
                        <mat-checkbox formControlName="Access_PlayerLoad"
                        ></mat-checkbox>
                      </div>
                      <div style="width: 100px;">
                        <mat-checkbox formControlName="Access_Test"
                        ></mat-checkbox>
                      </div>
                      <div style="width: 100px;">
                        <mat-checkbox formControlName="Access_Injury"
                        ></mat-checkbox>
                      </div>
                      <div style="width: 100px;">
                        <mat-checkbox formControlName="Access_Objective"
                        ></mat-checkbox>
                      </div>
                      <div style="width: 100px;">
                        <mat-checkbox formControlName="Access_Contacts"
                        ></mat-checkbox>
                      </div>
                      <!--  <div style="width: 100px;">
                      <mat-checkbox formControlName="Access_Training"
                      ></mat-checkbox>
                    </div> -->
                    <div style="width: 100px;">
                      <mat-checkbox formControlName="Access_Forms"
                      ></mat-checkbox>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      }
      <br/>
      <button  mat-raised-button color="primary" (click)="saveUser();">SAVE</button>
      &nbsp;
      <button  mat-button  (click)="cancel();">CANCEL</button>
    </form>
  }

</div>

</div>